// French (FR) — professional international French, suitable for France and
// Francophone African markets. AI-prepared, pending native review.
export default {
  "seo.title": "Ouvrez Votre Salle de Sport — Équipement Direct Usine | YANRE FITNESS EUROPE",
  "seo.description": "Du studio privé à la grande installation commerciale — équipement professionnel YANRE, conseil de projet personnalisé, logistique internationale et service après-vente garanti par l'usine.",

  "nav.Why Fitness": "Pourquoi le Fitness",
  "nav.Why YANRE": "Pourquoi YANRE",
  "nav.How It Works": "Comment Ça Marche",
  "nav.Real Projects": "Projets Réels",
  "nav.visitWebsite": "Visiter le Site",
  "header.cta": "Démarrer Votre Projet",

  "hero.label": "Ouvrez Votre Salle",
  "hero.line1": "Construisez votre salle de sport.",
  "hero.line2a": "Achetez directement auprès du",
  "hero.line2b": "fabricant.",
  "hero.copy": "Du studio privé à la grande installation commerciale — équipement professionnel YANRE, conçu et fabriqué par l'un des principaux fabricants chinois d'équipements de fitness professionnels, avec accompagnement commercial depuis l'Europe, conseil de projet personnalisé, logistique internationale et service après-vente garanti par l'usine.",
  "hero.ctaPrimary": "Démarrer Mon Projet de Salle",
  "hero.ctaSecondary": "Parler à un Spécialiste",
  "hero.trust.0": "Direct Usine",
  "hero.trust.1": "Conseil de Projet",
  "hero.trust.2": "Logistique Internationale",
  "hero.trust.3": "Garantie Usine",

  "marquee.Precision": "Précision",
  "marquee.Performance": "Performance",
  "marquee.Confidence": "Confiance",
  "marquee.Engineering": "Ingénierie",
  "marquee.Since 1997": "Depuis 1997",

  "strip.1": "Prêt à parler de votre projet ?",
  "strip.2": "Vous savez ce qu'il vous faut ? Parlons-en.",
  "strip.3": "Convaincu ? Lancez votre projet.",
  "strip.cta": "Démarrer Votre Projet",

  "label.Why Invest in Fitness": "Pourquoi Investir dans le Fitness",
  "label.Fitness Market Proof": "Preuves du Marché du Fitness",
  "label.New to Fitness? That's OK.": "Nouveau dans le Fitness ? Aucun Problème.",
  "label.Factory Direct": "Direct Usine",
  "label.Factory Direct Purchase Process": "Processus d'Achat Direct Usine",
  "label.Featured Equipment": "Équipement en Vedette",
  "label.Engineered Differently": "Une Ingénierie à Part",
  "label.Built Around Your Business": "Conçu Autour de Votre Activité",
  "label.Why YANRE FITNESS": "Pourquoi YANRE FITNESS",
  "label.The Founder": "Le Fondateur",
  "label.YANRE Gyms Around the World": "Les Salles YANRE dans le Monde",
  "label.International Logistics": "Logistique Internationale",
  "label.After-Sales & Warranty": "Après-Vente et Garantie",
  "label.Start Your Project": "Démarrez Votre Projet",
  "label.Milestones": "Étapes Clés",
  "label.Engineering Philosophy": "Philosophie d'Ingénierie",

  "wa.title": "WhatsApp",
  "wa.subtitle": "Parler à un Spécialiste",

  "footer.contact": "Contact",
  "footer.legal": "Mentions Légales",
  "footer.privacy": "Politique de Confidentialité",
  "footer.cookies": "Politique de Cookies",
  "footer.terms": "Conditions",
  "footer.visit": "Visiter le Site YANRE FITNESS EUROPE",

  "step.1": "Projet",
  "step.2": "Espace",
  "step.3": "Investissement",
  "step.4": "Contact",
  "step.5": "Besoins du Projet",
  "step.6": "Logistique",
  "step.7": "Achat",
  "step.8": "Votre Rôle",
  "step.9": "Localisation",
  "step.10": "Contact",
  "step.11": "Informations Finales",
  "form.progress": "Étape",
  "form.title1": "Construisez le projet",
  "form.title2": "de votre salle.",
  "form.subtitle": "Dites-nous ce que vous prévoyez. Nous vous aidons à construire la bonne solution d'équipement.",
  "form.intro.sub1": "4 ÉTAPES RAPIDES.",
  "form.intro.sub2": "UNE SOLUTION COMPLÈTE POUR VOTRE SALLE.",
  "form.intro.support": "Parlez-nous de votre projet en seulement 4 étapes simples. Notre équipe comprendra vos besoins et vous aidera à construire la bonne solution — avec fourniture directe d'usine de YANRE FITNESS Chine, conseil professionnel et service après-vente.",
  "form.intro.minute": "1 MINUTE POUR TERMINER",
  "form.back": "Retour",
  "form.continue": "Continuer",
  "form.submit": "Recevoir Mon Projet de Salle",
  "form.sending": "Envoi en cours…",

  "q.projectType": "Qu'est-ce qui décrit le mieux votre projet ?",
  "q.franchiseStatus": "Êtes-vous déjà associé à une franchise de fitness ?",
  "q.locationStatus": "Avez-vous déjà un local pour le projet ?",
  "q.facilityArea": "Quelle est la surface disponible approximative ?",
  "q.projectStage": "À quelle étape se situe actuellement votre projet ?",
  "q.openingTimeline": "Quand prévoyez-vous l'ouverture de votre projet ?",
  "q.investmentBand": "Quelle est votre fourchette d'investissement estimée ? (USD)",
  "q.investmentHint": "Une estimation suffit. Elle nous aide à recommander la solution adaptée à votre projet.",
  "q.projectNeed": "De quoi avez-vous besoin pour votre projet ?",
  "q.projectNeedHint": "Sélectionnez toutes les réponses applicables.",
  "q.equipmentListStatus": "Avez-vous déjà une liste d'équipement ?",
  "q.logisticsPreference": "Comment souhaitez-vous gérer la logistique internationale ?",
  "q.purchaseMethod": "Comment prévoyez-vous actuellement d'acheter votre équipement ?",
  "q.competitorComparison": "Comparez-vous actuellement d'autres marques d'équipement ?",
  "q.competitorBrands": "Quelles marques envisagez-vous ?",
  "q.decisionRole": "Quel est votre rôle dans ce projet ?",
  "q.country": "Pays du Projet",
  "q.city": "Ville",
  "q.firstName": "Prénom",
  "q.lastName": "Nom",
  "q.company": "Société / Nom de la Salle (optionnel)",
  "q.email": "Adresse E-mail",
  "q.phone": "WhatsApp / Téléphone",
  "q.preferredContact": "Moyen de Contact Préféré",
  "q.notes": "Souhaitez-vous nous dire autre chose sur votre projet ?",
  "q.optional": "Facultatif",
  "q.selectCountry": "Sélectionner un pays",

  "opt.commercial-gym": "Projet de Salle Complet",
  "opt.boutique-gym": "Salle Boutique",
  "opt.pt-studio": "Studio de Coaching Sportif",
  "opt.home-gym": "Salle Privée à Domicile",
  "opt.residential-gym": "Salle de Résidence / Copropriété",
  "opt.hotel-resort": "Fitness Hôtel / Resort",
  "opt.corporate-gym": "Salle d'Entreprise",
  "opt.sports-facility": "Installation Sportive / de Performance",
  "opt.franchise": "Franchise de Salle de Sport",
  "opt.other": "Autre",
  "opt.own-franchise": "Oui — je possède / exploite déjà une franchise",
  "opt.acquiring-franchise": "Oui — je suis en cours d'acquisition d'une franchise",
  "opt.evaluating-franchise": "J'évalue les opportunités de franchise",
  "opt.independent": "Non — j'explore le fitness en indépendant",
  "opt.confirmed": "Oui — emplacement confirmé",
  "opt.negotiating": "Emplacement en cours de négociation",
  "opt.looking": "Encore à la recherche d'un emplacement",
  "opt.up-to-100": "Jusqu'à 100 m²",
  "opt.100-250": "100–250 m²",
  "opt.250-500": "250–500 m²",
  "opt.500-1000": "500–1 000 m²",
  "opt.1000-2000": "1 000–2 000 m²",
  "opt.2000-plus": "2 000+ m²",
  "opt.exploring": "Exploration d'opportunités d'investissement",
  "opt.initial-planning": "Planification initiale",
  "opt.business-plan": "Business plan / Planification d'investissement",
  "opt.location-selected": "Emplacement sélectionné",
  "opt.architecture": "Architecture / Design",
  "opt.construction": "Construction / Rénovation",
  "opt.ready-to-purchase": "Prêt à acheter l'équipement",
  "opt.expansion": "Ouverture d'un nouveau site / Expansion",
  "opt.within-2": "Sous 2 mois",
  "opt.2-4": "2–4 mois",
  "opt.4-6": "4–6 mois",
  "opt.6-12": "6–12 mois",
  "opt.12-plus": "12+ mois",
  "opt.up-to-50k": "Moins de 50 000 USD",
  "opt.50-150k": "50 000–150 000 USD",
  "opt.150-300k": "150 000–300 000 USD",
  "opt.300-500k": "300 000–500 000 USD",
  "opt.500k-1m": "500 000–1M USD",
  "opt.1m-plus": "Plus de 1M USD",
  "opt.complete-equipment": "Équipement de Salle Complet",
  "opt.strength": "Équipement de Musculation",
  "opt.cardio": "Équipement de Cardio",
  "opt.full-project-help": "J'ai besoin d'aide pour le projet complet",
  "opt.have-list": "Oui — j'ai déjà une liste d'équipements",
  "opt.need-review": "Partiellement — j'ai une première sélection",
  "opt.need-list": "Non — j'ai besoin de l'aide de YANRE",
  "opt.yanre-coordination": "Je souhaite la coordination logistique YANRE",
  "opt.own-partner": "J'ai déjà un partenaire logistique",
  "opt.compare-both": "Je souhaite comparer les deux options",
  "opt.need-guidance": "J'ai besoin de conseils avant de décider",
  "opt.direct": "Directement auprès du fabricant",
  "opt.dealer": "Revendeur local d'équipement de fitness",
  "opt.distributor": "Distributeur / Importateur",
  "opt.comparing": "Comparaison de différentes options d'achat",
  "opt.researching": "Encore en recherche de fournisseurs",
  "opt.yes": "Oui",
  "opt.no": "Non",
  "opt.owner": "Propriétaire / Fondateur",
  "opt.investor": "Investisseur",
  "opt.partner": "Associé",
  "opt.director": "Directeur / Cadre",
  "opt.manager": "Gérant de Salle",
  "opt.procurement": "Achats / Approvisionnement",
  "opt.architect": "Architecte / Designer",
  "opt.consultant": "Consultant",
  "opt.trainer": "Personal Trainer",
  "opt.whatsapp": "WhatsApp",
  "opt.phone": "Appel Téléphonique",
  "opt.email": "E-mail",

  "err.projectType": "Sélectionnez ce que vous prévoyez de construire.",
  "err.franchiseStatus": "Précisez votre situation vis-à-vis des franchises.",
  "err.locationStatus": "Sélectionnez le statut de votre emplacement.",
  "err.facilityArea": "Sélectionnez la surface de fitness approximative.",
  "err.projectStage": "Sélectionnez l'étape de votre projet.",
  "err.openingTimeline": "Sélectionnez le calendrier d'ouverture prévu.",
  "err.investmentBand": "Sélectionnez votre investissement estimé en équipement.",
  "err.projectNeed": "Sélectionnez au moins un besoin du projet.",
  "err.equipmentListStatus": "Sélectionnez le statut de votre liste d'équipement.",
  "err.logisticsPreference": "Sélectionnez une préférence logistique.",
  "err.purchaseMethod": "Sélectionnez votre mode d'achat prévu.",
  "err.competitorComparison": "Indiquez si vous comparez d'autres marques.",
  "err.decisionRole": "Sélectionnez votre rôle dans ce projet.",
  "err.country": "Sélectionnez le pays du projet.",
  "err.city": "Indiquez la ville du projet.",
  "err.firstName": "Indiquez votre prénom.",
  "err.lastName": "Indiquez votre nom.",
  "err.email": "Indiquez une adresse e-mail valide.",
  "err.phone": "Indiquez votre numéro WhatsApp / téléphone.",
  "err.preferredContact": "Sélectionnez votre moyen de contact préféré.",
  "err.privacyConsent": "Veuillez accepter le consentement de confidentialité pour envoyer votre projet.",
  "err.submit": "Une erreur est survenue lors de l'envoi de votre projet. Veuillez réessayer.",

  "consent.privacy": "J'accepte que YANRE FITNESS EUROPE traite mes informations pour me contacter au sujet de ce projet.",
  "consent.marketing": "Je souhaite également recevoir occasionnellement des actualités et offres de YANRE FITNESS EUROPE. (Facultatif)",
  "success.title1": "Projet bien reçu",
  "success.body": "Merci. Un spécialiste YANRE FITNESS EUROPE examinera votre projet et vous contactera via votre canal préféré.",
  "success.reference": "Référence",

  // ===== Section copy =====
  "wi.h1a": "Vous cherchez votre prochaine activité ?",
  "wi.h1b": "Regardez le fitness.",
  "wi.fitnessCol": "Activité Fitness",
  "wi.retailCol": "Commerce Traditionnel",
  "wi.f1": "Abonnements récurrents",
  "wi.f2": "Aucun stock de marchandises",
  "wi.f3": "Aucun réapprovisionnement quotidien",
  "wi.f4": "Accès prépayé / récurrent",
  "wi.f5": "Potentiel d'exploitation allégée",
  "wi.f6": "Gestion digitale",
  "wi.f7": "Équipement = actif productif long terme",
  "wi.r1": "Vendre chaque jour",
  "wi.r2": "Du stock à gérer",
  "wi.r3": "Des achats constants",
  "wi.r4": "Des revenus transaction par transaction",
  "wi.r5": "Une exploitation avec inventaire",
  "wi.r6": "Plus de complexité opérationnelle",
  "wi.r7": "Le stock doit tourner en permanence",
  "wi.note": "Une comparaison structurelle de modèles économiques — pas un jugement sur d'autres secteurs.",
  "mp.s1": "Chiffre d'affaires du marché européen du fitness en 2025",
  "mp.s2": "Adhérents de clubs de fitness en Europe en 2025",
  "mp.s3": "Croissance moyenne mondiale des revenus du fitness en 2024",
  "mp.s4": "Marge EBITDA médiane des opérateurs participant à l'étude de benchmarking HFA citée",
  "mp.opsLabel": "Les grands opérateurs s'étendent",
  "mp.o1": "Adhérents gagnés par les 20 plus grands opérateurs européens en 2025",
  "mp.o2": "Chiffre d'affaires combiné des 20 plus grands opérateurs européens en 2025",
  "mp.o3": "Grandes opérations de fusion-acquisition dans le fitness européen en 2025",
  "mp.src": "Sources : Health & Fitness Association · EuropeActive / Deloitte. Données de benchmarking sectoriel — ne constituent pas une garantie de résultats individuels.",
  "nf.h1a": "Pas besoin de venir de",
  "nf.h1b": "l'industrie du fitness.",
  "nf.b1": "Vous apportez l'investissement et la vision commerciale.",
  "nf.b2": "Nous vous aidons à structurer la partie équipement du projet.",
  "fd.h1a": "Supprimez les intermédiaires.",
  "fd.h1b": "Pas l'accompagnement.",
  "fd.tradLabel": "Modèle traditionnel",
  "fd.directLabel": "YANRE Direct Usine",
  "fd.t1": "Fabricant",
  "fd.t2": "Distributeur / Importateur",
  "fd.t3": "Revendeur / Détaillant",
  "fd.t4": "Client",
  "fd.customer": "Client",
  "fd.trust": "Votre contrat d'équipement et vos paiements se font directement avec YANRE FITNESS — le fabricant, en Chine — avec un accompagnement commercial assuré depuis l'Europe.",
  "fd.supportLabel": "Direct usine ne signifie pas y aller seul",
  "fd.s1": "Conseil Personnalisé",
  "fd.s2": "Orientation Technique",
  "fd.s3": "Sélection d'Équipement",
  "fd.s4": "Accompagnement de Projet",
  "fd.s5": "Coordination Logistique Optionnelle",
  "fd.s6": "Service Après-Vente",
  "fd.s7": "Garantie Usine",
  "pp.h1a": "Un processus clair.",
  "pp.h1b": "Du projet à l'après-vente.",
  "pp.1.t": "Briefing du Projet",
  "pp.1.b": "Le client présente l'espace, le concept, l'investissement et le calendrier.",
  "pp.2.t": "Conseil YANRE",
  "pp.2.b": "Sélection d'équipement, orientation technique et configuration du projet.",
  "pp.3.t": "Contrat Usine",
  "pp.3.b": "Proposition finale et commande officielle d'équipement directement avec YANRE FITNESS.",
  "pp.4.t": "Paiement Usine de 30 %",
  "pp.4.b": "Acompte standard payé directement à YANRE FITNESS ; la commande entre en production.",
  "pp.5.t": "Production",
  "pp.5.b": "Fabrication et préparation de l'équipement.",
  "pp.6.t": "Paiement Usine de 70 %",
  "pp.6.b": "Solde standard payé directement à YANRE FITNESS après production et avant expédition, selon le contrat officiel.",
  "pp.7.t": "Expédition Internationale",
  "pp.7.b": "Le client peut utiliser son propre prestataire logistique ou demander une coordination logistique.",
  "pp.8.t": "Après-Vente",
  "pp.8.b": "Accompagnement continu et garantie usine après la livraison.",
  "pp.payTitle": "100 % des paiements d'équipement sont effectués directement à YANRE FITNESS.",
  "pp.paySub": "Aucun paiement d'équipement n'est effectué à des agents, consultants ou intermédiaires tiers.",
  "pp.disclaimer": "Structure de paiement standard présentée. Les conditions commerciales et de paiement finales sont définies dans le contrat de vente officiel YANRE FITNESS.",
  "fe.h1a": "Conçu pour performer.",
  "fe.h1b": "Fait pour être vu.",
  "fe.tagline": "Votre équipement fait partie de votre marque.",
  "fe.i0.cat": "Musculation Guidée",
  "fe.i0.series": "73 Tough Series",
  "fe.i0.stmt": "Musculation guidée conçue pour un usage professionnel quotidien.",
  "fe.i1.cat": "Plate Loaded",
  "fe.i1.series": "Plate-Loaded Power",
  "fe.i1.stmt": "Des machines plate-loaded construites autour du mouvement naturel.",
  "fe.i2.cat": "Double Fonction",
  "fe.i2.series": "C4D Double Fonction",
  "fe.i2.stmt": "Deux postes en un seul espace — densité d'entraînement maximale.",
  "fe.i3.cat": "Cardio Commercial",
  "fe.i3.series": "Cardio Commercial",
  "fe.i3.stmt": "Du cardio conçu pour les environnements commerciaux non-stop.",
  "dd.h1a": "La différence",
  "dd.h1b": "est dans les détails.",
  "dd.0.t": "Ingénierie Originale",
  "dd.0.s": "Un design développé par YANRE.",
  "dd.1.t": "Design Breveté",
  "dd.1.s": "Un design d'équipement original et breveté.",
  "dd.2.t": "Construction du Châssis",
  "dd.2.s": "Ingénierie du châssis et des tubes en gros plan.",
  "dd.3.t": "Design de Châssis Incurvé",
  "dd.3.s": "Géométrie du châssis façonnée autour du mouvement.",
  "dd.4.t": "Sellerie et Rembourrage",
  "dd.4.s": "Sellerie professionnelle, coutures et finition.",
  "dd.5.t": "Système Câbles / Poulies / Guides",
  "dd.5.s": "Des composants de mouvement de précision.",
  "dd.6.t": "Biomécanique",
  "dd.6.s": "Pivots et trajectoires de mouvement conçus autour du corps.",
  "dd.7.t": "Construction de Qualité Commerciale",
  "dd.7.s": "Conçue pour la durabilité et l'usage professionnel quotidien.",
  "bt.0": "Salle de Sport Commerciale",
  "bt.1": "Club de Fitness Premium",
  "bt.2": "Salle Boutique",
  "bt.3": "Studio de Personal Training",
  "bt.4": "Salle Force / Performance",
  "bt.5": "Installation d'Entraînement Fonctionnel",
  "bt.6": "Salle Privée Professionnelle à Domicile",
  "bt.7": "Salle Résidentielle / de Copropriété",
  "bt.8": "Hôtel / Resort",
  "bt.9": "Fitness d'Entreprise",
  "bt.10": "Site Franchisé",
  "wy.h1a": "Façonné par l'expérience.",
  "wy.h1b": "Construit pour la performance.",
  "wy.p1.t": "Fabrication",
  "wy.p1.b": "Fabrication interne de systèmes de musculation de qualité commerciale — conçus et produits par YANRE dans ses propres usines en Chine, pas assemblés à partir de designs tiers.",
  "wy.p2.t": "Ingénierie et Biomécanique",
  "wy.p2.b": "Design original depuis 1997, avec plus de 200 brevets couvrant l'ingénierie d'équipement et la biomécanique du mouvement.",
  "wy.p3.t": "Durabilité Commerciale",
  "wy.p3.b": "Un équipement conçu pour un usage professionnel quotidien, certifié selon les normes CE, TÜV et ISO.",
  "wy.p4.t": "Développement Produit",
  "wy.p4.b": "Une gamme pilotée par le fabricant — de la 73 Tough Series aux gammes plate-loaded, machines double fonction et cardio commercial.",
  "wy.p5.t": "Expérience Internationale",
  "wy.p5.b": "La confiance de salles professionnelles dans plus de 110 pays, avec plus de 34 950 projets de salles livrés dans le monde.",
  "wy.proof0": "Depuis 1997",
  "wy.proof1": "200+ Brevets",
  "wy.proof2": "110+ Pays",
  "wy.proof3": "CE · TÜV · ISO",
  "wy.proof4": "34 950+ Projets",
  "fo.navFactory": "L'Usine",
  "fo.navFounder": "L'Homme Derrière la Machine",
  "fo.h1a": "L'Homme",
  "fo.h1b": "Derrière",
  "fo.h1c": "la Machine.",
  "fo.role": "Fondateur et Designer en Chef",
  "fo.body": "Athlète, ingénieur et fondateur de YANRE. Depuis 1997, il construit des machines pour ceux qui valorisent l'ingénierie plus que le marketing.",
  "fo.quote": "« Pour comprendre la machine, il faut comprendre l'homme derrière. »",
  "fo.st1.t": "Le Début",
  "fo.st1.b": "En 1991, George Yang n'était pas encore fondateur — il était technicien, réparant des machines de gym pour l'Équipe Nationale d'Athlètes de Chine. Réparer a révélé la vérité ; il s'entraînait lui-même sur les machines pour sentir exactement où elles faillaient.",
  "fo.st2.t": "Le Problème",
  "fo.st2.b": "Même les « meilleures » marques du monde avaient des défauts — soudures fragiles, angles médiocres et designs qui ignoraient le corps humain. Les limites qu'il a vues ont façonné une manière entièrement différente de penser l'équipement.",
  "fo.st3.t": "La Fondation",
  "fo.st3.b": "En 1997, il a cessé de corriger les erreurs des autres et a fixé son propre standard — fondant Yangrui Fitness à Pékin, du nom de son fils. Le nom a évolué de Yangrui à Yanre puis YR ; le standard n'a jamais changé.",
  "fo.st4.t": "L'Ingénieur",
  "fo.st4.b": "Il refuse tout compromis sur les matériaux : acier qualifié Q235 de 3 mm minimum, barres 30CrMnSiA, cames et poulies POM à faible friction, et câbles importés du Japon résistants à 1400kg. « Je m'entraîne moi-même sur ces machines. »",
  "fo.st5.t": "Le Designer",
  "fo.st5.b": "Sa philosophie est épurée et minimaliste — le design n'est pas l'apparence, mais le fonctionnement. YANRE conçoit plutôt que copier ; la 73 Series a été la première au monde à utiliser des trajectoires de mouvement indépendantes, convergentes et divergentes.",
  "fo.st6.t": "La Vision",
  "fo.st6.b": "Une usine d'artisans, pas un entrepôt de cartons — commande minimum d'une unité, personnalisation réelle et accompagnement pensé pour la dixième année d'une salle, pas seulement son premier jour. Un partenaire, pas un patron.",
  "fo.m1.t": "Expérience Technique Initiale",
  "fo.m1.b": "Technicien de l'Équipe Nationale d'Athlètes de Chine.",
  "fo.m2.t": "Fondation de YANRE",
  "fo.m2.b": "Yangrui Fitness fondée à Pékin.",
  "fo.m3.t": "La 73 Series",
  "fo.m3.b": "Première mondiale avec trajectoires indépendantes, convergentes et divergentes.",
  "fo.pqA": "« Nous fabriquons des produits avec",
  "fo.pqHeart": "cœur",
  "fo.pqB": ", et nous fabriquons des produits avec des",
  "fo.pqStandard": "standards",
  "fo.pqEnd": ". »",
  "fo.c1.t": "Matériaux",
  "fo.c1.b": "Acier Q235, 3 mm minimum. Cames POM. Câbles 1400kg.",
  "fo.c2.t": "Biomécanique",
  "fo.c2.b": "Trajectoires de mouvement conçues autour du corps humain.",
  "fo.c3.t": "Durabilité",
  "fo.c3.b": "Conçu pour durer plus de 10 ans en usage professionnel.",
  "fo.c4.t": "Standard",
  "fo.c4.b": "ISO 20957 comme point de départ — jamais comme plafond.",
  "cc.h1a": "Des salles réelles.",
  "cc.h1b": "Des entreprises réelles.",
  "cc.h1c": "YANRE réel.",
  "cc.case0.title": "Look Premium. Installation Professionnelle.",
  "cc.case1.title": "Agencement Simple. Installation Solide.",
  "cc.case2.title": "Style Fonctionnel. Équipement Professionnel.",
  "cc.videoPending": "Vidéo complète du projet disponible sur demande",
  "lg.h1a": "Votre équipement. Votre destination.",
  "lg.h1b": "Votre choix.",
  "lg.option": "Option",
  "lg.o1.t": "Utilisez Votre Partenaire Logistique",
  "lg.o1.b": "Travaillez avec le prestataire logistique auquel vous faites déjà confiance. Nous préparons votre commande pour l'export et coordonnons avec votre partenaire.",
  "lg.o2.t": "Laissez-Nous Coordonner",
  "lg.o2.b": "Demandez la coordination logistique YANRE selon le périmètre contracté — de l'usine au port de destination.",
  "lg.f1": "Usine",
  "lg.f2": "Export",
  "lg.f3": "Fret Maritime",
  "lg.f4": "Port de Destination",
  "lg.disclaimer": "Dédouanement, taxes, droits et services du dernier kilomètre ne sont inclus que lorsqu'ils sont explicitement contractés.",
  "lg.cta": "Inclure la Logistique dans Mon Projet",
  "as.h1a": "La relation ne s'arrête pas",
  "as.h1b": "quand le conteneur part.",
  "as.1.t": "Garantie Usine",
  "as.1.b": "Garantie du fabricant pour votre équipement.",
  "as.2.t": "Support Technique",
  "as.2.b": "Assistance technique directe, reliée à ceux qui conçoivent l'équipement.",
  "as.3.t": "Support Pièces Détachées",
  "as.3.b": "Support pièces au niveau fabricant pour vos machines.",
  "as.4.t": "Assistance Après-Vente",
  "as.4.b": "Assistance après-vente continue après la livraison.",

  // Cookie consent & policy
  "ck.title": "Vos choix de confidentialité",
  "ck.desc": "Nous n'utilisons des cookies facultatifs d'analyse et de publicité qu'avec votre consentement. Vous pouvez modifier ou retirer votre choix à tout moment.",
  "ck.acceptAll": "Tout Accepter",
  "ck.reject": "Refuser les Non Essentiels",
  "ck.manage": "Gérer les Préférences",
  "ck.save": "Enregistrer les Préférences",
  "ck.necessary": "Nécessaires",
  "ck.necessaryDesc": "Indispensables au fonctionnement du site. Toujours actifs.",
  "ck.analytics": "Analyse",
  "ck.analyticsDesc": "Statistiques d'utilisation anonymes qui nous aident à améliorer ce site.",
  "ck.advertising": "Publicité",
  "ck.advertisingDesc": "Utilisés pour mesurer les campagnes et diffuser des publicités pertinentes.",
  "ck.alwaysOn": "Toujours actifs",
  "ck.prefsTitle": "Préférences de Cookies",
  "ck.policy": "Politique de Cookies",
  "ck.privacy": "Politique de Confidentialité",
  "footer.cookiePrefs": "Préférences de Cookies",
  "cp.title": "Politique de Cookies",
  "cp.updated": "Dernière mise à jour : juillet 2026",
  "cp.intro": "Cette page explique comment YANRE FITNESS EUROPE utilise les cookies et technologies similaires sur ce site, et comment vous pouvez les contrôler.",
  "cp.s1t": "Ce que nous stockons",
  "cp.s1b": "Lorsque vous faites un choix de consentement, nous stockons uniquement ce choix (nécessaires, analyse, publicité) dans le stockage local de votre navigateur. Il ne contient aucune information personnelle et sert uniquement à mémoriser votre préférence entre les visites.",
  "cp.s2t": "Catégories de cookies",
  "cp.s3t": "Google Tag Manager et Mode de Consentement",
  "cp.s3b": "Ce site charge un conteneur Google Tag Manager avec le Mode de Consentement v2 de Google. Tout stockage facultatif (analyse et publicité) est défini sur « denied » par défaut et n'est activé qu'après votre consentement explicite. Aucune balise d'analyse ou de publicité n'est installée directement sur ce site.",
  "cp.s4t": "Gérer votre consentement",
  "cp.s4b": "Vous pouvez modifier ou retirer votre consentement à tout moment via le lien « Préférences de Cookies » dans le pied de page. Le retrait prend effet immédiatement.",
  "cp.s5t": "Contact",
  "cp.privacyT": "Confidentialité",
  "cp.privacyB": "Notre Politique de Confidentialité complète est en cours de finalisation. Pour toute question ou demande concernant vos données personnelles, contactez-nous à l'adresse email ci-dessus.",
  "cp.back": "Retour à l'Accueil",

  "q.fullName": "Nom Complet",
  "opt.upgrade-expand": "Rénovation / Extension d'une Salle Existante",
  // ===== PERSONAL TRAINER STUDIO (pts.*) — fr =====
  "pts.seo.title": "Studio de Coaching Sportif — Équipement de Gym Professionnel | YANRE FITNESS",
  "pts.seo.description": "Ouvrez votre propre studio de coaching avec l'équipement professionnel YANRE, en direct fabricant. Packs de démarrage intelligents, aménagement de l'espace et accompagnement direct usine.",
  "pts.nav.talk": "Parler à un Spécialiste",
  "pts.header.cta": "Créer Mon Studio",
  "pts.hero.label": "Studio de Coaching Sportif",
  "pts.hero.line1": "Votre Studio.",
  "pts.hero.line2": "Vos Clients.",
  "pts.hero.line3": "Votre Business.",
  "pts.hero.subhead": "Créez votre studio de coaching professionnel avec YANRE.",
  "pts.hero.copy": "De votre premier studio privé à un espace premium de coaching — équipement professionnel YANRE, fabriqué directement dans les usines du groupe en Chine, avec aménagement intelligent de l'espace et accompagnement commercial depuis l'Europe.",
  "pts.hero.ctaPrimary": "Créer Mon Studio",
  "pts.hero.ctaSecondary": "Parler à un Spécialiste",
  "pts.hero.trust.0": "Qualité Professionnelle",
  "pts.hero.trust.1": "Direct Fabricant",
  "pts.hero.trust.2": "Garantie Usine",
  "pts.hero.trust.3": "Support Logistique",
  "pts.journey.label": "La Transition",
  "pts.journey.h2a": "De Coach Sportif",
  "pts.journey.h2b": "à Propriétaire de Studio.",
  "pts.journey.copy": "Entraîner des clients dans la salle d'un autre construit son business. Votre propre studio construit le vôtre — votre espace, vos relations clients, votre marque, votre actif. L'indépendance commence avec une salle et le bon équipement.",
  "pts.journey.0": "Coach Sportif",
  "pts.journey.1": "Votre Propre Studio",
  "pts.journey.2": "Vos Propres Clients",
  "pts.journey.3": "Votre Propre Marque",
  "pts.journey.4": "Votre Propre Business",
  "pts.journey.direct": "Direct Fabricant.",
  "pts.journey.directCopy": "Équipez votre studio avec un équipement professionnel acheté directement auprès de YANRE — le fabricant qui conçoit et produit chaque machine.",
  "pts.journey.note": "Pas de promesses, pas de raccourcis — juste la structure pour transformer votre métier en un business qui vous appartient.",
  "pts.pkg.label": "Deux Façons de Commencer",
  "pts.pkg.h2a": "Commencez intelligemment.",
  "pts.pkg.h2b": "Grandissez à votre rythme.",
  "pts.pkg.intro": "Un studio professionnel commence par un pack d'équipement soigneusement sélectionné — et grandit avec le temps. Chaque composition est personnalisée selon votre espace, votre méthodologie d'entraînement et votre niveau d'investissement.",
  "pts.pkg.tag": "Pack",
  "pts.pkg.starter.name": "Starter",
  "pts.pkg.starter.pos": "Tout ce qu'il faut pour ouvrir un studio de coaching privé et professionnel.",
  "pts.pkg.starter.i0": "Premier studio",
  "pts.pkg.starter.i1": "Coachs sportifs",
  "pts.pkg.starter.i2": "Petits espaces",
  "pts.pkg.starter.i3": "Coaching 1 à 3",
  "pts.pkg.starter.i4": "Coaching semi-privé",
  "pts.pkg.starter.concept": "Une combinaison soigneusement sélectionnée de machines de musculation essentielles, d'équipement fonctionnel et de poids libres.",
  "pts.pkg.starter.cta": "Créer Mon Studio Starter",
  "pts.pkg.studiopro.name": "Studio Pro",
  "pts.pkg.studiopro.pos": "Une configuration professionnelle complète pour un business de coaching premium.",
  "pts.pkg.studiopro.i0": "Coachs sportifs établis",
  "pts.pkg.studiopro.i1": "Studios premium",
  "pts.pkg.studiopro.i2": "Capacité clients supérieure",
  "pts.pkg.studiopro.i3": "Coaching en petits groupes",
  "pts.pkg.studiopro.i4": "Entraînement performance",
  "pts.pkg.studiopro.concept": "Une combinaison plus complète de machines de musculation, d'équipement fonctionnel, de poids libres et de cardio.",
  "pts.pkg.studiopro.cta": "Créer Mon Studio Pro",
  "pts.pkg.idealFor": "Idéal pour",
  "pts.pkg.conceptLabel": "Concept d'équipement",
  "pts.pkg.quote": "Demandez votre devis projet",
  "pts.pkg.note": "Pas de prix fixes en ligne — chaque studio fait l'objet d'un devis projet, composé selon votre espace, votre méthodologie et votre niveau d'investissement.",
  "pts.eq.label": "Conçu pour le Vrai Entraînement",
  "pts.eq.h2a": "Qualité professionnelle.",
  "pts.eq.h2b": "Conçu pour un usage quotidien intensif.",
  "pts.eq.copy": "Les mêmes gammes d'équipement qui servent les salles commerciales — châssis conçus pour durer, mouvement breveté et durabilité testée en usine — adaptées intelligemment à un studio de coaching privé.",
  "pts.eq.strength": "Musculation",
  "pts.eq.functional": "Entraînement Fonctionnel",
  "pts.eq.freeweights": "Poids Libres",
  "pts.eq.benches": "Bancs et Racks",
  "pts.eq.cable": "Stations à Câbles",
  "pts.eq.cardio": "Cardio",
  "pts.eq.alt.strength": "Machines de musculation professionnelles YANRE pour studios de coaching",
  "pts.eq.alt.functional": "Équipement d'entraînement fonctionnel YANRE pour studios de fitness professionnels",
  "pts.eq.alt.freeweights": "Équipement professionnel de poids libres YANRE pour studios de coaching",
  "pts.eq.alt.benches": "Bancs et racks professionnels YANRE pour studios de coaching",
  "pts.eq.alt.cable": "Stations à câbles professionnelles YANRE pour studios de coaching",
  "pts.eq.alt.cardio": "Équipement cardio professionnel YANRE pour studios de coaching",
  "pts.space.label": "Aménagement de l'Espace",
  "pts.space.h2a": "Votre espace.",
  "pts.space.h2b": "Votre projet.",
  "pts.space.copy": "Il n'y a pas deux studios identiques. La sélection d'équipement et l'aménagement sont conçus autour de votre réalité — pas un pack catalogue figé.",
  "pts.space.f0": "Surface disponible",
  "pts.space.f1": "Méthodologie d'entraînement",
  "pts.space.f2": "Nombre de clients simultanés",
  "pts.space.f3": "Niveau d'investissement",
  "pts.space.f4": "Achat Direct Usine",
  "pts.space.f4d": "Équipement professionnel YANRE sans couches de revente inutiles.",
  "pts.space.f5": "Studio Prêt à Exploiter",
  "pts.space.f5d": "Équipement professionnel, aménagement intelligent et un concept de studio complet, prêt à accueillir votre activité.",
  "pts.space.cta": "Démarrer Mon Projet de Studio",
  "pts.direct.label": "Direct Fabricant",
  "pts.direct.h2a": "Sans intermédiaires.",
  "pts.direct.h2b": "Sans compromis.",
  "pts.direct.copy": "YANRE est le fabricant — il conçoit et produit son propre équipement professionnel depuis 1997 dans ses usines en Chine, avec un accompagnement commercial assuré depuis l'Europe. Votre projet, votre contrat d'équipement et votre garantie vivent directement avec l'usine qui construit vos machines.",
  "pts.direct.p0": "Équipement qualité professionnelle",
  "pts.direct.p1": "Relation directe avec le fabricant",
  "pts.direct.p2": "Garantie soutenue par l'usine",
  "pts.direct.p3": "Support logistique international",
  "pts.direct.p4": "Conseil de projet",
  "pts.direct.p5": "Support après-vente",
  "pts.process.label": "Comment Ça Marche",
  "pts.process.h2a": "Un processus clair.",
  "pts.process.h2b": "De l'idée au jour de l'ouverture.",
  "pts.process.1.t": "Consultation",
  "pts.process.1.b": "Nous comprenons votre profil, votre espace, votre concept et votre niveau d'investissement.",
  "pts.process.2.t": "Projet",
  "pts.process.2.b": "Ensemble, nous définissons la sélection d'équipement et l'aménagement du studio.",
  "pts.process.3.t": "Commande — 30 %",
  "pts.process.3.b": "Confirmez le projet et lancez la production avec un paiement de 30 % à l'usine.",
  "pts.process.4.t": "Production",
  "pts.process.4.b": "YANRE fabrique et prépare votre équipement.",
  "pts.process.5.t": "70 % Avant Expédition",
  "pts.process.5.b": "Le solde est réglé avant l'expédition, selon le contrat officiel.",
  "pts.process.6.t": "Expédition",
  "pts.process.6.b": "Logistique internationale coordonnée pour votre projet.",
  "pts.process.7.t": "Après-Vente",
  "pts.process.7.b": "Support garanti par l'usine après l'installation.",
  "pts.monetize.label": "Monétisez les Heures Creuses du Studio",
  "pts.monetize.h2a": "Faites travailler votre studio",
  "pts.monetize.h2b": "même quand vous n'êtes pas là.",
  "pts.monetize.copy": "Votre studio ne doit pas créer de la valeur uniquement quand vous entraînez vos propres clients. Les heures creuses peuvent devenir une source de revenus supplémentaire en donnant à d'autres coachs sportifs l'accès à votre espace d'entraînement professionnel.",
  "pts.monetize.clients": "Vos Clients",
  "pts.monetize.clientsSub": "Vos propres séances de coaching",
  "pts.monetize.hours": "Heures Disponibles",
  "pts.monetize.hoursSub": "D'autres coachs utilisent votre studio",
  "pts.monetize.revenue": "Une Source de Revenus en Plus",
  "pts.monetize.revenueSub": "Exploitez mieux votre espace tout au long de la journée",
  "pts.monetize.closeA": "Le studio vous appartient.",
  "pts.monetize.closeB": "Vous contrôlez le planning.",
  "pts.form.label": "Lancez Votre Projet de Studio",
  "pts.form.h2a": "Parlez-nous de",
  "pts.form.h2b": "votre studio.",
  "pts.form.sub": "Deux minutes. Un spécialiste répond avec une proposition d'équipement concrète pour votre espace et votre budget.",
  "pts.form.intro.sub1": "4 ÉTAPES RAPIDES.",
  "pts.form.intro.sub2": "UNE SOLUTION COMPLÈTE POUR VOTRE STUDIO.",
  "pts.form.intro.support": "Parlez-nous de votre studio en seulement 4 étapes simples. Notre équipe comprendra vos besoins et vous aidera à construire la bonne solution — avec fourniture directe d'usine de YANRE FITNESS Chine, conseil professionnel et service après-vente.",
  "pts.form.intro.minute": "1 MINUTE POUR TERMINER",
  "pts.form.progress": "Étape",
  "pts.form.back": "Retour",
  "pts.form.continue": "Continuer",
  "pts.form.submit": "Recevoir Mon Projet de Studio",
  "pts.form.sending": "Envoi…",
  "pts.form.err.step": "Veuillez compléter les champs obligatoires pour continuer.",
  "pts.form.err.submit": "Une erreur est survenue lors de l'envoi de votre projet. Veuillez réessayer.",
  "pts.success.title": "Votre projet de studio a bien été reçu.",
  "pts.success.body": "Un spécialiste YANRE étudiera vos informations et vous contactera pour discuter de votre studio, de vos besoins en équipement et des prochaines étapes.",
  "pts.success.reference": "Référence",
  "pts.success.cta": "Visiter YANRE FITNESS",
  "pts.q.areYou": "Qu'est-ce qui vous décrit le mieux ?",
  "pts.q.planning": "Que prévoyez-vous ?",
  "pts.q.package": "Quel pack studio vous intéresse ?",
  "pts.q.location": "Avez-vous déjà un local ?",
  "pts.q.size": "Surface approximative du studio :",
  "pts.q.timeline": "Quand prévoyez-vous d'ouvrir votre studio ?",
  "pts.q.investment": "Quel est votre budget d'investissement estimé ? (USD)",
  "pts.q.needs": "De quoi avez-vous besoin ?",
  "pts.q.needsHint": "Sélectionnez tout ce qui s'applique.",
  "pts.q.country": "Pays",
  "pts.q.city": "Ville",
  "pts.q.fullName": "Nom Complet",
  "pts.q.email": "Email",
  "pts.q.phone": "Téléphone / WhatsApp",
  "pts.q.company": "Société / Nom du Studio (optionnel)",
  "pts.q.selectCountry": "Sélectionnez le pays",
  "pts.step.1": "Studio",
  "pts.step.2": "Espace",
  "pts.step.3": "Investissement",
  "pts.step.4": "Contact",
  "pts.step.5": "Besoins en Équipement",
  "pts.step.6": "Contact",
  "pts.opt.role.personal-trainer": "Coach Sportif",
  "pts.opt.role.sc-coach": "Préparateur Physique",
  "pts.opt.role.studio-owner": "Propriétaire de Studio",
  "pts.opt.role.investor-entrepreneur": "Investisseur / Entrepreneur",
  "pts.opt.role.other": "Autre",
  "pts.opt.plan.first-studio": "Ouvrir mon premier studio",
  "pts.opt.plan.upgrade-studio": "Améliorer mon studio actuel",
  "pts.opt.plan.another-location": "Ouvrir un autre site",
  "pts.opt.pkg.starter": "STARTER",
  "pts.opt.pkg.studio-pro": "STUDIO PRO",
  "pts.opt.pkg.need-help": "J'ai besoin d'aide pour choisir",
  "pts.opt.loc.confirmed": "Oui",
  "pts.opt.loc.looking": "En recherche",
  "pts.opt.loc.not-yet": "Pas encore",
  "pts.opt.size.under-50": "Moins de 50 m²",
  "pts.opt.size.50-100": "50–100 m²",
  "pts.opt.size.100-200": "100–200 m²",
  "pts.opt.size.over-200": "Plus de 200 m²",
  "pts.opt.size.undefined": "Pas encore défini",
  "pts.opt.time.1-2": "1–2 mois",
  "pts.opt.time.2-4": "2–4 mois",
  "pts.opt.time.4-6": "4–6 mois",
  "pts.opt.time.6-plus": "Plus de 6 mois",
  "pts.opt.inv.under-10k": "Moins de 10 000",
  "pts.opt.inv.10-20k": "10 000–20 000",
  "pts.opt.inv.20-40k": "20 000–40 000",
  "pts.opt.inv.40-80k": "40 000–80 000",
  "pts.opt.inv.80k-plus": "Plus de 80 000 USD",
  "pts.opt.need.complete-studio-equipment": "Équipement Complet de Studio",
  "pts.opt.need.strength": "Machines de Musculation",
  "pts.opt.need.functional": "Entraînement Fonctionnel",
  "pts.opt.need.cardio": "Équipement Cardio",
  "pts.opt.need.full-project-help": "J'ai besoin d'aide pour le projet complet",
  "pts.opt.role.gym-owner-operator": "Propriétaire / Exploitant de Salle",
  "pts.opt.inv.under-20k": "Moins de 20 000 USD",
  "pts.opt.inv.20-30k": "20 000–30 000 USD",
  "pts.opt.inv.30-50k": "30 000–50 000 USD",
  "pts.opt.inv.50-80k": "50 000–80 000 USD",
  "err.phoneInvalid": "Veuillez saisir un numéro de téléphone valide pour le pays sélectionné.",
  "footer.tagline": "YANRE FITNESS EUROPE — la maison européenne d'un fabricant international établi de systèmes de musculation et de solutions fitness complètes de qualité commerciale.",
};
